(function () {
  const config = window.brMetaPixel;
  if (!config?.id || window.fbq) return;

  function eventId(prefix) {
    const value = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    return `br-${prefix}-${value}`;
  }

  function loadPixel() {
    if (window.fbq) return;
    const fbq = window.fbq = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', config.id);
    fbq('track', 'PageView', {}, {eventID: eventId('page')});

    const productRoot = document.querySelector('[data-product-root]');
    if (productRoot) {
      fbq('track', 'ViewContent', {
        content_ids: [productRoot.dataset.productId],
        content_name: productRoot.dataset.productTitle,
        content_type: 'product',
        value: Number(productRoot.dataset.productPrice || 0) / 100,
        currency: config.currency,
      }, {eventID: eventId('view')});
    }
  }

  function analyticsAllowed() {
    return !window.Shopify?.customerPrivacy || window.Shopify.customerPrivacy.analyticsProcessingAllowed();
  }

  if (analyticsAllowed()) loadPixel();
  document.addEventListener('visitorConsentCollected', () => {
    if (analyticsAllowed()) loadPixel();
  });

  document.addEventListener('br:add-to-cart', (event) => {
    if (!window.fbq) return;
    const item = event.detail;
    window.fbq('track', 'AddToCart', {
      content_ids: [String(item.variant_id || item.id)],
      content_name: item.product_title,
      content_type: 'product',
      value: Number(item.final_price || item.price || 0) / 100,
      currency: config.currency,
    }, {eventID: eventId('cart')});
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.closest('[data-checkout-form]') || !window.fbq) return;
    window.fbq('track', 'InitiateCheckout', {
      value: Number(event.target.dataset.cartTotal || 0) / 100,
      currency: config.currency,
    }, {eventID: eventId('checkout')});
  });
})();
